/**
 * 🚀 Modul Assistant SDK - Punto de Entrada Principal
 * @version 1.0.0
 * @description SDK modular para chat inteligente en cualquier sitio web
 * @author Modul Team
 */

import { ModulAssistantSDK } from "./core/sdk.js";

// Crear instancia global del SDK
const sdkInstance = new ModulAssistantSDK();

// Exponer en el objeto window para uso directo
if (typeof window !== "undefined") {
  window.ModulAssistantSDK = sdkInstance;
}

// Exportar para uso como módulo ES6
export default sdkInstance;

// Exportar también las clases individuales para uso avanzado
export { ModulAssistantSDK } from "./core/sdk.js";
export { HTTPClient } from "./core/http-client.js";
export { MessageProcessor } from "./core/message-processor.js";
export { EventManager } from "./core/event-manager.js";
export { ChatWidget } from "./ui/chat-widget.js";
export { ThemeManager } from "./ui/theme-manager.js";
export { ThemeStyles } from "./ui/theme-styles.js";

/**
 * 🎯 Funciones de conveniencia para uso rápido
 */

/**
 * 🚀 Inicialización rápida del SDK
 * @param {Object} options - Opciones de configuración
 * @returns {Promise<Object>} Respuesta de inicialización
 */
export const initSDK = async (options) => {
  return await sdkInstance.init(options);
};

/**
 * 💬 Envío rápido de mensaje
 * @param {string} message - Mensaje a enviar
 * @returns {Promise<Object>} Respuesta del chat
 */
export const sendMessage = async (message) => {
  return await sdkInstance.sendMessage(message);
};

/**
 * 🔍 Test rápido de conectividad
 * @returns {Promise<Object>} Respuesta del test
 */
export const testConnection = async () => {
  return await sdkInstance.test();
};

/**
 * 🎨 Cambio rápido de tema
 * @param {string} theme - Nuevo tema
 */
export const changeTheme = (theme) => {
  sdkInstance.changeTheme(theme);
};

/**
 * 📊 Información rápida del SDK
 * @returns {Object} Información del SDK
 */
export const getSDKInfo = () => {
  return sdkInstance.getInfo();
};

/**
 * 🗑️ Destrucción rápida del SDK
 * @returns {Object} Información sobre la destrucción
 */
export const destroySDK = () => {
  return sdkInstance.destroy();
};

// Información del SDK
export const SDK_VERSION = "1.0.0";
export const SDK_NAME = "Modul Assistant SDK";

// Log de inicialización
if (typeof window !== "undefined" && window.console) {
  console.log(`
🚀 ${SDK_NAME} v${SDK_VERSION} cargado
📚 Documentación: https://docs.gomodul.com/assistant-sdk
💬 Soporte: https://gomodul.com/soporte
  `);
}
